module.exports = __webpack_public_path__ + "00_glasses.7428199c.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/aoyama/dad/layer4/00_glasses.png
// module id = lpT/
// module chunks = 0